import React from 'react';
import styled from 'styled-components';

import { useElementOverflow } from '../../hooks/use-element-overflow';

type Props = {
  text: string;
};

/**
 * Wraps text with a block container and sets text as title if text overflows the container.
 */
const EllipsisContainer = (props: Props) => {
  const { ref, isOverflowed } = useElementOverflow<HTMLDivElement>();

  return (
    <Component ref={ref} title={isOverflowed ? props.text : ''}>
      {props.text}
    </Component>
  );
};

const Component = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export { EllipsisContainer };
